// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const enamorus_incarnate: PokeData = {
  "id": 905,
  "name": "enamorus-incarnate",
  "height": 16,
  "weight": 480,
  "base_experience": 116,
  "types": [
    PokeType.FAIRY,
    PokeType.FLYING
  ],
  "api_moves": [
    "tackle",
    "bite",
    "outrage",
    "twister",
    "crunch",
    "uproar",
    "torment",
    "flatter",
    "superpower",
    "imprison",
    "astonish",
    "extrasensory",
    "iron-defense",
    "healing-wish",
    "draining-kiss",
    "fairy-wind",
    "moonblast",
    "mystical-fire",
    "dazzling-gleam",
    "springtide-storm"
  ],
  "moves": [
    "tackle",
    "bite",
    "outrage",
    "crunch",
    "flatter",
    "superpower",
    "healing-wish",
    "moonblast",
    "dazzling-gleam",
    "chatter",
    "brave-bird",
    "tailwind",
    "play-rough"
  ],
  "evolution_chain": {
    "id": 477,
    "item": null,
    "species": [
      {
        "name": "enamorus",
        "order": 905,
        "types": [
          PokeType.FAIRY,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 134,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
